/*
 * Keeps the header cart icon's count bubble in sync with the real cart,
 * independent of Shopify's page-level caching (which can serve a stale
 * server-rendered count until a hard refresh).
 *
 * Also excludes free (₹0) gift line items (e.g. the Parfum Pouch) from
 * the visible count, matching the cart/drawer UI which hides them.
 *
 * Re-syncs on initial load, on bfcache restores (back/forward navigation
 * showing a cached page), and whenever other cart scripts dispatch the
 * 'cart:refresh' / 'cart:updated' events already used elsewhere in the
 * theme after an AJAX cart change.
 */
(function () {
  function syncCartBubble() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var visibleCount = 0;
        (cart.items || []).forEach(function (item) {
          if (item.final_line_price > 0) {
            visibleCount += item.quantity;
          }
        });

        document.querySelectorAll('[id="cart-icon-bubble"]').forEach(function (bubbleRoot) {
          var bubble = bubbleRoot.querySelector('.cart-count-bubble');

          if (visibleCount <= 0) {
            if (bubble) bubble.remove();
            return;
          }

          if (!bubble) {
            bubble = document.createElement('span');
            bubble.className = 'cart-count-bubble';

            var numberSpan = document.createElement('span');
            numberSpan.setAttribute('aria-hidden', 'true');
            bubble.appendChild(numberSpan);

            var srSpan = document.createElement('span');
            srSpan.className = 'visually-hidden';
            bubble.appendChild(srSpan);

            bubbleRoot.appendChild(bubble);
          }

          bubble.classList.toggle('cart-count-bubble--dot', visibleCount >= 100);
          bubble.style.display = '';

          var numberEl = bubble.querySelector('[aria-hidden="true"]');
          if (numberEl) numberEl.textContent = visibleCount < 100 ? visibleCount : '';
        });
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', syncCartBubble);

  // bfcache restore (browser back/forward showing a cached page snapshot)
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) syncCartBubble();
  });

  // Re-sync after any AJAX cart change elsewhere in the theme
  document.addEventListener('cart:refresh', syncCartBubble);
  document.addEventListener('cart:updated', syncCartBubble);
})();
